import { render, staticRenderFns } from "./upTrainImage.vue?vue&type=template&id=0b682786&"
import script from "./upTrainImage.vue?vue&type=script&lang=js&"
export * from "./upTrainImage.vue?vue&type=script&lang=js&"
import style0 from "./upTrainImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports